import type { Ctx } from "../../types";
import { Query } from "gg-wf-scripts";
import { applyListParams } from "../_shared";
import { decorateUser, usersListSortMap, usersSearchCols } from "./_helpers";

export const users_list: Query<Ctx> = async ({ sb }, params) => {
  let query = sb.from("v_users_list").select("*");
  query = applyListParams(query, params, {
    search: usersSearchCols,
    sort: {
      map: usersListSortMap,
      default: [{ column: "last_name" }, { column: "first_name" }],
    },
  });
  const { data } = await query;
  if (!data) return [];
  return data.map(decorateUser);
};
